<template>
  <div class="container-fluid terms">
    <nav id="nav">
      <div class="cont_nav">
        <img width="115px;" src="./../assets/logo-01.png">
      </div>
    </nav>
    <main>
      <div class="text">
        <h1>Términos y condiciones Plantsss</h1>
        <p id="terms" v-html="info"></p>
        </div>
    </main>
    <footer>
      <div class="cont_footer">
        <p>
          <a href="http://www.plantsss.com" target="_blank">
            Plantsss.com
          </a>
        </p>
        <div class="cont_img">
          <a v-bind:href="playstoreUrl" target="_blank">
            <img width="120px" src="./../assets/playstore.png">
          </a>
          <a v-bind:href="appstoreUrl" target="_blank">
            <img width="120px" src="./../assets/appstore.png">
          </a>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
const axios = require('axios');

export default {
  name: 'Terms',
  data() {
    return {
      info: '',
      appstoreUrl: process.env.VUE_APP_APPSTORE_URL,
      playstoreUrl: process.env.VUE_APP_PLAYSTORE_URL,
    };
  },
  created() {
    document.title = 'T&C | Plantsss';
  },
  mounted() {
    axios
      .get(`${process.env.VUE_APP_API_SERVER}/api/v1/config`)
      .then((response) => {
        (this.info = response.data.status === 1 ? response.data.data[0].terms : '');
      });
  },
};
</script>

<style lang="scss" scoped>
.container-fluid {
  border: 0;
  padding: 0;
  margin: 0;
}

.terms {
  background: url(../assets/bg-01.png) no-repeat center center fixed;
  -webkit-background-size: cover;
  -moz-background-size: cover;
  -o-background-size: cover;
  background-size: cover;
  font-family: 'Roboto', sans-serif;

  .container-fluid {
    padding-right: 0px;
    padding-left: 0px;
  }
}

main {
  width: 700px;
  background: white;
  padding: 35px 20px 25px 30px;
  margin: 20px auto;
  border-radius: 4px;
  p {
    margin-top: 10px;
    width: 100%;
  }
}

a,
p,
span {
  float: left;
  font-size: 13px;
}

.text {
  width: 100%;
  box-sizing: border-box;
  padding: 10px 7% 0 5%;
  border-left: 1px solid #d2d1d1;
  color: #777777;
  height: 74vh;
  overflow-y: auto;
}

nav {
  width: 100%;
  height: 80px;
  background: white;
  -webkit-box-shadow: 0 1px 23px 0px black;
  box-shadow: 0 1px 23px 0px black;
}
.cont_nav {
  max-width: 900px;
  margin: auto;
  padding: 8px 0px;
}
footer {
  width: 100%;
  height: 70px;
  background: white;
  position: relative;
}
.cont_footer {
  width: 900px;
  margin: auto;
  p {
    color: #898989;
    margin-top: 25px;
  }
  span {
    margin-left: 3px;
  }
  p>a {
    margin-left: 6px;
  }
  a {
    color: #213624;
    text-decoration: none;
  }
  a:hover {
    text-decoration: underline;
  }
  img:last-child {
    margin-left: 10px;
  }
  .cont_img {
    float: right;
    display: block;
    margin-top: 15px;
  }
}

@media screen and (max-width: 768px) {
  .terms {
    nav {
      .cont_nav {
        width: 100%;
        padding-left: 15px;
        padding-right: 15px;
        box-sizing: border-box;
      }
    }

    main {
      width: 90%;
      box-sizing: border-box;
    }

    footer {
      height: auto;
    }

    .cont_footer {
      width: 100%;
      padding-left: 15px;
      padding-right: 15px;
      box-sizing: border-box;
      text-align: -webkit-center;
      text-align: center;

      p {
        float: none;
        padding-top: 20px;
        margin: auto;
        display: inline-block;
      }

      .cont_img {
        float: none;
        margin-top: 10px;
        padding-bottom: 1em;

        a {
          float: none;
        }
      }
    }
  }
}
</style>
